"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_TYPE = {
    DATE: 'DATE',
    FILE: 'FILE',
    ID: 'ID',
    JSON: 'JSON',
    MISSING_RELATION: 'MISSING_RELATION',
    NUMBER: 'NUMBER',
    ONE_WAY_RELATION: 'ONE_WAY_RELATION',
    RELATION: 'RELATION',
    SMART: 'SMART',
    SWITCH: 'SWITCH',
    TEXT: 'TEXT',
    GEO: 'GEO',
};
exports.SWITCH_FORMATS = {
    ACTIVE_INACTIVE: 'ACTIVE_INACTIVE',
    CUSTOM: 'CUSTOM',
    HIGH_LOW: 'HIGH_LOW',
    ON_OFF: 'ON_OFF',
    TRUE_FALSE: 'TRUE_FALSE',
    YES_NO: 'YES_NO',
};
exports.SWITCH_VALUES = {
    ACTIVE_INACTIVE: {
        false: 'Inactive',
        true: 'Active',
    },
    HIGH_LOW: {
        false: 'Low',
        true: 'High',
    },
    ON_OFF: {
        false: 'Off',
        true: 'On',
    },
    TRUE_FALSE: {
        false: 'False',
        true: 'True',
    },
    YES_NO: {
        false: 'No',
        true: 'Yes',
    },
};
exports.TEXT_FORMATS = {
    HTML: 'HTML',
    MARKDOWN: 'MARKDOWN',
    EIN: 'EIN',
    EMAIL: 'EMAIL',
    NAME: 'NAME',
    PHONE: 'PHONE',
    SSN: 'SSN',
    UNFORMATTED: 'UNFORMATTED',
};
exports.NUMBER_FORMATS = {
    CURRENCY: 'CURRENCY',
    FRACTION: 'FRACTION',
    NUMBER: 'NUMBER',
    PERCENTAGE: 'PERCENTAGE',
    SCIENTIFIC: 'SCIENTIFIC',
};
exports.FILE_FORMATS = {
    FILE: 'FILE',
    IMAGE: 'IMAGE',
};
exports.SMART_FORMATS = {
    ADDRESS: 'ADDRESS',
    PHONE: 'PHONE',
};
exports.DATE_FORMATS = {
    DATE: 'DATE',
    DATETIME: 'DATETIME',
};
exports.MUTATION_TYPE = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
};
exports.GEO_FORMATS = {
    GEOMETRY: 'GEOMETRY',
    POINT: 'POINT',
    LINESTRING: 'LINESTRING',
    POLYGON: 'POLYGON',
};
exports.SYSTEM_TABLES = {
    API_TOKENS: 'ApiTokens',
    ENVIRONMENT_VARIABLES: 'EnvironmentVariables',
    FILES: 'Files',
    TEAM_INVITATIONS: 'TeamInvitations',
    PERMISSIONS: 'Permissions',
    ROLES: 'Roles',
    SETTINGS: 'Settings',
    USERS: 'Users',
    CI_CD_MIGRATIONS: 'CiCdMigrations',
    AUTHENTICATION_PROFILES: 'AuthenticationProfiles',
    AUTHENTICATION_SETTINGS: 'AuthenticationSettings',
    TEAM_MEMBERS: 'TeamMembers',
};
exports.MUTATION_FILE_FIELDS = ['id', 'fileId', 'public', 'filename', 'meta', 'mods'];
exports.APP_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};
exports.APP_TYPES = {
    SALESFORCE: 'salesforce',
};
exports.FIELD_KINDS = {
    USER: 'USER',
    SYSTEM: 'SYSTEM',
    EXTERNAL: 'EXTERNAL',
};
exports.TABLE_ORIGIN_TYPES = {
    LOCAL: 'LOCAL',
    VIEW: 'VIEW',
    REMOTE: 'REMOTE',
};
exports.UPDATE_META_FIELDS_TO_PRESERVE = {
    id: true,
};
//# sourceMappingURL=schemaConstants.js.map